import { atom } from 'recoil';

export const atomAlertsCount = atom({
  key: 'atomAlertsCount', 
  default: 0, 
});
export default atomAlertsCount;